import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import HBButton, { TButtonStyle } from '../honeybook-ui/HBButton/HBButton';
import { NonUsaWarningModalWrapper } from '../NonUsaWarningModalWrapper/NonUsaWarningModalWrapper';
import { useRegistrationForm } from '../../hooks/useRegistrationForm';

import './registration-form.scss';

interface Props {
    showNoCcRequired?: boolean;
    direction?: 'row' | 'column';
    size?: 'x-small' | 'small' | 'medium' | 'large';
    customClass?: string;
    source: string;
    buttonText?: string;
    dataForIntakeFormTest?: Record<string, any>;
    buttonStyle?: TButtonStyle;
    couponCode?: string;
    testId?: string;
    signupRedirectUrl?: string;
    handleSignupRedirectUrlCallback?: () => void;
    onBeforeSubmit?: () => Promise<void>;
    shouldShowButtonLoader?: boolean;
    icon?: string;
    dataForIntentMarketingAi?: Record<string, any>;
    openInNewTab?: boolean;
}

const RegistrationForm = ({
    showNoCcRequired,
    direction = 'column',
    size = 'medium',
    customClass,
    source,
    buttonText,
    dataForIntakeFormTest,
    buttonStyle,
    couponCode,
    testId,
    signupRedirectUrl,
    handleSignupRedirectUrlCallback,
    shouldShowButtonLoader,
    onBeforeSubmit,
    icon,
    dataForIntentMarketingAi,
    openInNewTab
}: Props) => {
    const { t } = useTranslation();
    const {
        isLoading,
        isOpenNonUsaModal,
        buttonTextVariant,
        handleSubmit,
        completeRegistrationForm,
        setIsOpenNonUsaModal
    } = useRegistrationForm({
        source,
        couponCode,
        dataForIntakeFormTest,
        dataForIntentMarketingAi,
        signupRedirectUrl,
        handleSignupRedirectUrlCallback,
        onBeforeSubmit,
        shouldShowButtonLoader,
        openInNewTab
    });

    const displayButtonText = buttonText || buttonTextVariant;

    return (
        <section
            className={`registration-form__container registration-form__container--${direction} ${
                customClass || ''
            }`.trim()}
        >
            <NonUsaWarningModalWrapper
                isOpenNonUsaModal={isOpenNonUsaModal}
                onCloseNonUsaModal={() => setIsOpenNonUsaModal(false)}
                onConfirmNonUsaModal={completeRegistrationForm}
            />

            <div className="registration-form__form-container">
                <HBButton
                    isDisabled={isLoading}
                    isLoading={isLoading || shouldShowButtonLoader}
                    size={size}
                    data-testid={testId || 'start-trial--button'}
                    type="submit"
                    text={displayButtonText}
                    buttonStyle={buttonStyle}
                    onClick={handleSubmit}
                    icon={icon}
                />

                {showNoCcRequired && (
                    <div className="registration-form__no-cc-required">
                        {t('registrationForm.noCcRequired') as string}
                    </div>
                )}
            </div>
        </section>
    );
};

export default memo(RegistrationForm);
